export const ticketsInfoStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		maxWidth: '495px',
		width: '100%',
		margin: '0 auto',
		marginBottom: '24px',
	},

	disabledAmount: {
		color: 'var(--neutral-300)',
	},

	header: {
		'& .MuiTypography-root': {
			fontSize: '12px',
			color: 'var(--neutral-300)',

			'&:not(:first-of-type)': {
				textAlign: 'end',
			},
		},
		display: 'flex',
		justifyContent: 'space-between',

		'& > :nth-of-type(1)': {
			maxWidth: '140px',
			width: '100%',
		},
		'& > :nth-of-type(2)': {
			maxWidth: '60px',
			width: '100%',
		},
		'& > :nth-of-type(3)': {
			maxWidth: '120px',
			width: '100%',
		},
		'& > :nth-of-type(4)': {
			maxWidth: '60px',
			width: '100%',
		},
	},

	content: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'space-between',
		gap: '16px',
		flexDirection: 'column',
	},

	contentItem: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		textAlign: 'end',
		gap: '32px',
		maxWidth: '495px',

		'& > :nth-of-type(1)': {
			width: '140px',
			flexShrink: 0,
			textAlign: 'start',
			fontWeight: 700,
		},
		'& > :nth-of-type(2)': {
			width: '60px',
			flexShrink: 0,
			fontSize: '16px',
		},
		'& > :nth-of-type(3)': {
			border: `1px solid var(--neutral-200)`,
			borderRadius: 'var(--default--border-radius)',
			width: '120px',
			flexShrink: 0,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: '44px',
		},
		'& > :nth-of-type(4)': {
			width: '60px',
			flexShrink: 0,
			color: 'var(--primary-700)',
			textAlign: 'end',
		},
	},

	amount: {
		fontSize: '16px',
		fontWeight: 700,
	},

	deleteButton: {
		minWidth: '44px',
	},

	disabledDeleteButton: {
		'& svg path': {
			fill: 'var(--neutral-200)',
		},
	},
	addButton: {
		'& svg path': {fill: 'var(--neutral-900)'},
		minWidth: '44px',
	},

	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		'& .MuiTypography-root': {color: 'var(--primary-700)'},
		marginBottom: '40px',
	},

	error: {
		bottom: '68px',
		right: '0',
	},

	moneyIconWrapper: {
		display: 'flex',
		alignItems: 'center',

		svg: {
			path: {
				fill: 'var(--primary-500)',
			},
		},
	},

	disabledIcon: {
		svg: {
			path: {
				fill: 'var(--primary-200)',
			},
		},
	},

	button: {
		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},

	amountWrapper: {
		display: 'flex',
		gap: '16px',
		border: `1px solid var(--neutral-200)`,
		borderRadius: 'var(--default--border-radius)',
		width: '160px',
		height: '44px',
		justifyContent: 'center',
		alignItems: 'center',
	},
};
